import { LogisticsInfoDTOListVo } from '@/apis/order/order.interface';
import UKPageNothing, { DefaultImageType } from '@/components/UKPageNothing';
import UKTruncatedTooltip from '@/components/UKTruncatedTooltip';
import { useTranslation } from '@/i18n/client';
import cn from 'clsx';
import { observer } from 'mobx-react';
import styles from './index.module.scss';

interface stepperProps {
  logisticsInfoDTOList: LogisticsInfoDTOListVo[];
}

const stepper: React.FC<stepperProps> = observer(({ logisticsInfoDTOList }) => {
  const { t } = useTranslation();

  return logisticsInfoDTOList?.length ? (
    logisticsInfoDTOList.map((item, index) => {
      return (
        <div
          key={index}
          className={cn(styles.stepper_item, { [styles.active_stepper_item]: index === 0 })}
        >
          <div className={styles.divider_wrap}>
            <i className={styles.dot_style} />
            {index !== logisticsInfoDTOList.length - 1 ? <i className={styles.line_style} /> : null}
          </div>
          <div className={styles.title_wrap}>
            {item.stateDesc ? <div className={styles.title_style}>{item.stateDesc}</div> : null}
            {item.message ? (
              <UKTruncatedTooltip
                text={item.message}
                tooltipStyles={cn(styles.sub_title_style)}
                tooltipProps={{ placement: 'top' }}
                textLines={2}
              />
            ) : null}
            {/* @ts-ignore */}
            <UKTruncatedTooltip
              text={item?.position || ''}
              tooltipStyles={cn(styles.detail_address_style)}
              tooltipProps={{ placement: 'top' }}
              textLines={2}
            />
            <div className={styles.date_style}>
              {item?.messageDate}, {item?.messageTime}
            </div>
          </div>
        </div>
      );
    })
  ) : (
    <div className={styles.wrap}>
      <UKPageNothing
        style={{ padding: '40px 0' }}
        defaultImageWidth={72}
        defaultImageHeight={72}
        defaultImageType={DefaultImageType.DEFAULT_NOTING}
        text={t('order.orderList.emptyPage.trackTip')}
      />
    </div>
  );
});

export default stepper;
